import Swal from 'sweetalert2';
import requestChangeClothes from '../changeClothes/requestChangeClothes';

export default async function handleCustomClothes() {
  let prefilledText = '';

  // Step 1: Explain the feature with enhanced UI
  const step1 = await Swal.fire({
    title: "✨ Personalizza l'Abbigliamento",
    html: `
      <div class="custom-clothes-intro">
        <p class="mb-3" style="font-size: 16px; color: #333;">
          Descrivi l'abito che hai in mente o che la famiglia ha richiesto e la nostra intelligenza artificiale lo creerà su misura per il defunto.
        </p>
        <p class="mb-4" style="font-size: 14px; color: #6c757d;">
          👇 Clicca su un esempio per utilizzarlo
        </p>
        
        <div class="examples-grid">
          <div class="example-card" onclick="window.customClothesExample = 'Camice bianco da medico con stetoscopio al collo'">
            <div class="example-title">⚕️ Professione</div>
            <div class="example-text">"Camice medico con stetoscopio"</div>
          </div>
          <div class="example-card" onclick="window.customClothesExample = 'Maglia azzurra del Napoli'">
            <div class="example-title">⚽ Squadra del Cuore</div>
            <div class="example-text">"Maglia del Napoli"</div>
          </div>
          <div class="example-card" onclick="window.customClothesExample = 'Giacca di pelle nera da motociclista'">
            <div class="example-title">🏍️ Passione Motori</div>
            <div class="example-text">"Giacca da moto"</div>
          </div>
          <div class="example-card" onclick="window.customClothesExample = 'Abito da cerimonia'">
            <div class="example-title">🌹 Momento Speciale</div>
            <div class="example-text">"Abito da cerimonia"</div>
          </div>
        </div>
        
      </div>
    `,
    width: '750px',
    showCancelButton: true,
    confirmButtonText: 'Inizia a Creare',
    cancelButtonText: 'Annulla',
    confirmButtonColor: '#667eea',
    customClass: {
      confirmButton: 'btn btn-primary btn-lg',
      cancelButton: 'btn btn-light btn-lg',
    },
    didOpen: () => {
      // Handle example card clicks
      window.customClothesExample = null;
      const exampleCards = document.querySelectorAll('.example-card');
      exampleCards.forEach((card) => {
        card.addEventListener('click', () => {
          Swal.clickConfirm();
        });
      });
    },
    preConfirm: () => {
      if (window.customClothesExample) {
        prefilledText = window.customClothesExample;
      }
      return true;
    },
  });

  if (!step1.isConfirmed) {
    return;
  }

  // Step 2: Get user input with enhanced design
  const step2 = await Swal.fire({
    title: "🎨 Descrizione dell'Abbigliamento",
    html: `
      <div>
        <textarea
          id="custom-clothes-input"
          class="custom-input"
          placeholder="Descrivi l'abbigliamento desiderato... (es. 'Completo elegante blu scuro')"
          rows="3"
        >${prefilledText}</textarea>
        
        <div class="text-left">
          <small class="text-muted d-block mb-2">Suggerimenti rapidi:</small>
          <div class="suggestion-chips">
            <span class="chip" onclick="document.getElementById('custom-clothes-input').value = 'Camicia a quadri rossi e blu'">Camicia preferita</span>
            <span class="chip" onclick="document.getElementById('custom-clothes-input').value = 'Giacca di pelle marrone vintage'">Giacca di pelle</span>
            <span class="chip" onclick="document.getElementById('custom-clothes-input').value = 'Camicia hawaiana con palme e fiori'">Camicia hawaiana</span>
            <span class="chip" onclick="document.getElementById('custom-clothes-input').value = 'Costume tradizionale tirolese con bretelle'">Abito tradizionale</span>
            <span class="chip" onclick="document.getElementById('custom-clothes-input').value = 'Smoking nero con farfallino rosso'">Smoking elegante</span>
            <span class="chip" onclick="document.getElementById('custom-clothes-input').value = 'Polo verde con logo ricamato'">Polo club golf</span>
            <span class="chip" onclick="document.getElementById('custom-clothes-input').value = 'Maglietta nera dei Pink Floyd'">Maglietta band</span>
            <span class="chip" onclick="document.getElementById('custom-clothes-input').value = 'Vestito floreale giallo e bianco'">Vestito floreale</span>
          </div>
        </div>
        
        <div class="tips-box text-left">
          <div class="tips-title">💡 Per risultati migliori:</div>
          <ul class="tips-list">
            <li>Specifica il colore desiderato</li>
            <li>Indica lo stile (elegante, casual, sportivo)</li>
            <li>Aggiungi dettagli distintivi (loghi, scritte, accessori)</li>
          </ul>
        </div>
      </div>
    `,
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: '✨ Crea Abito',
    cancelButtonText: 'Annulla',
    confirmButtonColor: '#667eea',
    customClass: {
      confirmButton: 'btn btn-primary btn-lg',
      cancelButton: 'btn btn-light btn-lg',
    },
    didOpen: () => {
      // Auto-focus the textarea
      document.getElementById('custom-clothes-input').focus();
    },
    preConfirm: () => {
      const input = document.getElementById('custom-clothes-input');
      const value = input.value.trim();

      if (!value) {
        Swal.showValidationMessage("Per favore descrivi l'abito che desideri");
        return false;
      }

      if (value.length < 5) {
        Swal.showValidationMessage(
          'La descrizione deve essere più dettagliata (almeno 5 caratteri)'
        );
        return false;
      }

      // Show loading state
      Swal.showLoading();

      return value;
    },
  });

  if (!step2.isConfirmed || !step2.value) {
    return;
  }

  // Use the custom prompt with requestChangeClothes
  const customPrompt = step2.value;

  // Show epic processing message
  Swal.fire({
    title: '✨ Magia in corso...',
    html: `
      <div class="epic-processing-container">
        <div class="magic-particles">
          <div class="particle particle-1"></div>
          <div class="particle particle-2"></div>
          <div class="particle particle-3"></div>
          <div class="particle particle-4"></div>
          <div class="particle particle-5"></div>
          <div class="particle particle-6"></div>
          <div class="particle particle-7"></div>
          <div class="particle particle-8"></div>
          <div class="particle particle-9"></div>
        </div>
        
        <div class="magic-orb">
          <div class="orb-ring orb-ring-1"></div>
          <div class="orb-ring orb-ring-2"></div>
          <div class="orb-ring orb-ring-3"></div>
          <div class="orb-core"></div>
          <div class="sparkle sparkle-1"></div>
          <div class="sparkle sparkle-2"></div>
          <div class="sparkle sparkle-3"></div>
          <div class="sparkle sparkle-4"></div>
          <div class="sparkle sparkle-5"></div>
          <div class="sparkle sparkle-6"></div>
        </div>
        
        <div class="processing-text">L'intelligenza artificiale sta tessendo l'abito perfetto...</div>
        <div class="processing-subtext">"${customPrompt}"</div>
      </div>
    `,
    allowOutsideClick: false,
    showConfirmButton: false,
    timer: 3500,
    timerProgressBar: true,
    customClass: {
      popup: 'animated fadeIn',
      timerProgressBar: 'swal2-timer-progress-bar-epic',
    },
    didOpen: () => {
      // Add gradient to progress bar
      const progressBar = Swal.getTimerProgressBar();
      if (progressBar) {
        progressBar.style.background =
          'linear-gradient(to right, #667eea, #764ba2)';
      }
    },
  });

  // Call the same API logic used for garment clicks
  // We pass null for clothingUrl since we're using a custom prompt
  // The color will be extracted from the user's description
  requestChangeClothes(null, customPrompt, '');
}
